import React from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { takeEvery, call, put } from 'redux-saga/effects';
import Button from '@material-ui/core/Button';
import api from '../../apis/dataApi';
import { UPLOAD_IMAGE } from './constants';
import * as actions from './actions';

function getErrorMessage(error) {
  const errorMessage = _.get(error, 'response.data.message');
  return errorMessage ? `Reason: ${errorMessage}` : 'Please try again';
}

export function createFileFormData(file) {
  const fileFormData = new FormData();
  fileFormData.append('file', file, file.name);
  return fileFormData;
}

export function* uploadImageSaga({ payload }) {
  console.log('About to upload image', payload);
  const { file, thumbnailHeight, thumbnailWidth, action } = payload;
  const {
    alert,
    closeAlert,
    onSuccess = () => {},
    onError = () => {}
  } = payload.options;

  try {
    const fileFormData = yield call(createFileFormData, file);
    console.log('Starting upload...', fileFormData);
    const response = yield call(
      api.postImage,
      fileFormData,
      thumbnailHeight,
      thumbnailWidth,
      action
    );
    console.log('Upload finished', response);
    const image = response.data;
    yield put(actions.uploadImageDone(image));
    onSuccess({ image });
  } catch (error) {
    console.log('Error uploading image', error);
    yield put(
      alert({
        title: <FormattedMessage id="notify.uploadImageFail" />,
        content: getErrorMessage(error),
        actions: {
          right: [
            <Button key="stay" onClick={closeAlert} color="primary">
              <FormattedMessage id="notify.alertOk" />
            </Button>
          ]
        }
      })
    );
    yield put(actions.uploadImageFail());
    onError(error);
  }
}

export default [takeEvery(UPLOAD_IMAGE, uploadImageSaga)];
